import * as civils2000 from './civils2000ClaudeProfessionals';
import * as bbbeeMasterclass from './bbbeeMasterclass';
import * as bbbeeAwarenessHalfday from './bbbeeAwarenessHalfday';
import * as bbbeeProfessional3day from './bbbeeProfessional3day';
import * as esgFoundationsReporting from './esgFoundationsReporting';
import * as esgFulldayPractitioner from './esgFulldayPractitioner';
import * as esgProfessional3day from './esgProfessional3day';
import * as okiruSystemsSetup from './okiruSystemsSetup';
import * as welcomeToOkiru from './welcomeToOkiru';
import * as financeForNonFinanceManagers from './financeForNonFinanceManagers';
import * as creditAnalysisLending from './creditAnalysisLending';

// Presentations ship as static content (manifest + slides) committed to the
// repo, same pattern as the LMS's other lesson content — adding a new deck
// means adding a module here, not a database migration.
const REGISTRY = {
  [civils2000.manifest.id]: civils2000,
  [bbbeeMasterclass.manifest.id]: bbbeeMasterclass,
  [bbbeeAwarenessHalfday.manifest.id]: bbbeeAwarenessHalfday,
  [bbbeeProfessional3day.manifest.id]: bbbeeProfessional3day,
  [esgFoundationsReporting.manifest.id]: esgFoundationsReporting,
  [esgFulldayPractitioner.manifest.id]: esgFulldayPractitioner,
  [esgProfessional3day.manifest.id]: esgProfessional3day,
  [okiruSystemsSetup.manifest.id]: okiruSystemsSetup,
  [welcomeToOkiru.manifest.id]: welcomeToOkiru,
  [financeForNonFinanceManagers.manifest.id]: financeForNonFinanceManagers,
  [creditAnalysisLending.manifest.id]: creditAnalysisLending,
};

export function getPresentation(presentationId) {
  return REGISTRY[presentationId] || null;
}

export function listPresentations() {
  return Object.values(REGISTRY).map((p) => p.manifest);
}
